__turbopack_context__.v({
  "phoneContainer": "flags-module-scss-module__a8h4eG__phoneContainer",
  "phoneDropdown": "flags-module-scss-module__a8h4eG__phoneDropdown",
});
